'use client'

import { RadioGroupProps } from '@mui/joy'
import { forwardRef } from 'react'
import UIRadioGroupRoot from './UIRadioGroupRoot'

export interface UIRadioGroupProps extends Omit<RadioGroupProps, 'variant'> {}

const UIRadioGroup = forwardRef<HTMLInputElement, UIRadioGroupProps>((props, ref) => {
	return <UIRadioGroupRoot ref={ref} {...props} />
})
export default UIRadioGroup
